var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"title":"Content Applications","product-type":"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }